import { kuiperClassNames } from '@opallabs/kuiper'
import './styles.scss'

const PlaceholderContentListItem = () => (
  <div className={kuiperClassNames('contentListItem', 'isLoading')}>
    <div className={kuiperClassNames('service')} />
    <div className={kuiperClassNames('bar')} />
  </div>
)

export default PlaceholderContentListItem
